import { FC } from "react";
import { useTranslation } from "react-i18next";
import { TextPage } from "../../registration/staticPages/TextPage";
import { RegistrationFormResource } from "../../shared/types";
import { RenderRegistrationBlock } from "../RenderRegistrationBlock";

interface Props {
	registrationForm: RegistrationFormResource;
}

export const EmailGateInvitedPage: FC<Props> = ({ registrationForm }) => {
	const { t } = useTranslation();

	return registrationForm.emailGateWelcomeBlockId ? (
		<RenderRegistrationBlock blockId={registrationForm.emailGateWelcomeBlockId} />
	) : (
		<TextPage headline={t("Welcome")} text={t("An email with an invitation has been sent to you.")} />
	);
};
